import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Keycloak from 'keycloak-js';

export interface AuthenticationSlice {
  kcObject: Keycloak | null;
}

const initialState: AuthenticationSlice = {
  kcObject: null
};

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    setKcObject: (state, action: PayloadAction<Keycloak>) => {
      state.kcObject = action.payload;
    }
  }
});

export const { setKcObject } = authenticationSlice.actions;
export default authenticationSlice.reducer;
